/* eslint-disable jira/filename-case */

import type { RouteResourceResponse, ResourceStoreContext } from '../../../common/types.tsx';
import type { ResourceStoreData } from '../../common/types.tsx';
import type { ResourceSliceIdentifier, State } from './types.tsx';
import { getDefaultStateSlice } from './utils/get-default-state-slice/getDefaultStateSlice.tsx';

const defaultStateSlice = getDefaultStateSlice();

export const getSliceForResource = (
	state: { data: ResourceStoreData; context?: ResourceStoreContext },
	props: ResourceSliceIdentifier,
): RouteResourceResponse => {
	const { type, key } = props;
	const slice = state.data[type] && (state.data[type][key] as RouteResourceResponse);

	// The return of this needs to be stable object references - no cloning/spreading or new objects
	// otherwise it will cause re-renders in components that use this selector
	return slice || defaultStateSlice;
};

export const getResourceStoreContext = (state: State): ResourceStoreContext => state.context;
